import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { getUsers } from '../../actions/user-actions';
import { BsFillTrashFill } from "react-icons/bs";
import { searchListQuery } from '../../actions/global-actions';
import Paginator from '../../components/paginator/paginator';


function UsersList(){
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const user = useSelector(state => state.user.user);
    const [skip, setSkip] = useState(0);
    const [searchData, setSearchData] = useState({
        isSearching: false,
        value: ''
    });
    const [paginatorData, setPaginatorData] = useState({
        totalitems: 0,
        totalpages: 0,
        currentpage: 0
    });

    useEffect(() => {
        const getFunction = (response) => {
            let data = response.data;
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
            }else{
                //console.log(data);
                setUsers(data.data);

                setPaginatorData({
                    ...paginatorData,
                    ...response.headers,
                })
            }
        }

        if (loadData) {
            setLoadData(false);
            setUsers([]);
            if (searchData.isSearching) {
                dispatch( searchListQuery( 'user', searchData.value, getFunction, skip, user.token ) );

            } else {
                dispatch( getUsers( skip, getFunction, user.token ) );
            }
        }
    }, [loadData, dispatch, user.token, skip, searchData, paginatorData]);

    const searchFunction = (event) => {
        let value = event.target.value;
        if (value.length > 2) {
            stockPaginator();
            setSearchData({
                isSearching: true,
                value
            });
            setLoadData(true);
        } else {
            if (value.length === 0) {
                stockPaginator();
                setSearchData({
                    isSearching: false,
                    value: ''
                });
                setLoadData(true);
            }
        }
    }

    const stockPaginator = () => {
        setSkip(0);
        setPaginatorData({
            totalitems: 0,
            totalpages: 0,
            currentpage: 0
        });
    }

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <h1 className="my-5">Usuarios</h1>
                <div className="d-flex justify-content-between">
                    <div className="d-flex w-50">
                        <input className="input-field w-75" type="text" onChange={searchFunction} placeholder="Buscar un usuario por nombre, apellido o documento"/>
                    </div>
                    <Link to="/usuarios/nuevo" className="primary-button">Añadir nuevo usuario +</Link>
                </div>
                <table className="list-table my-5">
                    <thead>
                        <tr>
                            <th>Nombres</th>
                            <th>Apellidos</th>
                            <th>Correo</th>
                            <th>Tipo doc</th>
                            <th>Documento</th>
                            <th>Tarjeta profesional</th>
                            <th>Tipo</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, index) => (
                            <tr key={index}>
                                <td> <Link to={`/usuarios/editar/${user._id}`} key={user._id}>{user.firstName}</Link> </td>
                                <td> <Link to={`/usuarios/editar/${user._id}`} key={user._id}>{user.lastName}</Link> </td>
                                <td> <Link to={`/usuarios/editar/${user._id}`} key={user._id}>{user.email}</Link> </td>
                                <td> <Link to={`/usuarios/editar/${user._id}`} key={user._id}>{user.documentType}</Link> </td>
                                <td> <Link to={`/usuarios/editar/${user._id}`} key={user._id}>{user.document}</Link> </td>
                                <td> <Link to={`/usuarios/editar/${user._id}`} key={user._id}>{user.professionalCard}</Link> </td>
                                <td> <Link to={`/usuarios/editar/${user._id}`} key={user._id}>{user.userType}</Link> </td>
                                <td>
                                    <BsFillTrashFill className='trash-icon' />
                                </td>
                            </tr> 
                        ))}
                    </tbody>
                </table>
                {paginatorData.totalpages > 0 && paginatorData.currentpage > 0? 
                    <Paginator skip={skip} data={paginatorData} setSkip={(n) => setSkip(n)} setLoadData={(need) => setLoadData(need)} />
                :
                    null
                }
            </div>
        </div>
    );
}

export default UsersList;
  